import qs from 'qs'
import axios from 'axios'
import store from "@/store/index"
import router from '@/router'

class Http {
  
  defaultApi = process.env.VUE_APP_DEFAULT_API;
  defaultInstance;
  
  constructor() {    
    let _defaultInstance = axios.create({ baseURL: this.defaultApi});
    this.addInterceptors(_defaultInstance);
    this.defaultInstance = _defaultInstance;
  }
  
  newInstance(_url){
    let _instance = axios.create({ baseURL: _url});
    this.addInterceptors(_instance);
    return _instance
  }
  
  get(path, instance = this.defaultInstance) {
    return instance.get(path)
  }

  delete(path, instance = this.defaultInstance) {
    return instance.delete(path)
  }

  post(path, payload, instance = this.defaultInstance) {
    return instance.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data:  qs.stringify(payload)
    })
  }

  postMultipart(path, payload, instance = this.defaultInstance) {
    return instance.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      headers: {
          'Content-Type': 'multipart/form-data'
      },
      data:  (payload)
    })
  } 

  downloadFiles(path, payload, instance = this.defaultInstance) {
    return instance.request({
      method: 'POST',
      url: path,
      responseType: 'blob',
      data:  qs.stringify(payload)
    })
  }

  update(path, payload, instance = this.defaultInstance) {
    return instance.request({
      method: 'PUT',
      url: path,
      responseType: 'json',
      data:  qs.stringify(payload)
    })
  }

  addInterceptors(instance){

    instance.interceptors.request.use((config) => {
      config.headers.common['secret']         = 'BoxLogisticsSystem'
      config.headers.common['x-access-token'] = store.state.userInfoData.boxkey;
      config.headers.common['authorization']  = store.state.userInfoData.boxkey;
      return config
    })

    instance.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      // Do something with response error
      if(error.response.status == 403){
        store.dispatch('auth/logout');
        router.push('/login');
      }
      return Promise.reject(error);
    });
  }



}


export default new Http